import type {
  CreateTimesheetAdjustment,
  CreateTimesheetPayload,
  PayPeriodSettings,
  PayrollMapping,
  PayrollMappingPayload,
  RejectTimesheetPayload,
  Timesheet,
  TimesheetReviewNotice,
  TimesheetReconciliation,
  UpdatePayPeriodSettings,
  VersionCommand,
  XeroTimesheetExportResult,
} from "./generated/openapi";
import { apiRequest, queryString } from "./http";

export type { PayPeriodSettings, Timesheet, TimesheetStatus } from "./generated/openapi";

export const timesheetApi = {
  reviewNotices: () => apiRequest<TimesheetReviewNotice[]>("/api/timesheets/review-notices"),
  settings: () => apiRequest<PayPeriodSettings>("/api/timesheets/settings"),
  current: () => apiRequest<Timesheet>("/api/timesheets/current"),
  sendCurrentToXero: () =>
    apiRequest<XeroTimesheetExportResult>("/api/timesheets/current/send-to-xero", { method: "POST" }),
  reconcileCurrent: () =>
    apiRequest<TimesheetReconciliation>("/api/timesheets/current/reconcile"),
  updateSettings: (payload: UpdatePayPeriodSettings) =>
    apiRequest<PayPeriodSettings>("/api/timesheets/settings", { method: "PUT", body: JSON.stringify(payload) }),
  list: (params: { period_start?: string; user_id?: string } = {}) =>
    apiRequest<Timesheet[]>(`/api/timesheets${queryString(params)}`),
  create: (payload: CreateTimesheetPayload) =>
    apiRequest<Timesheet>("/api/timesheets", { method: "POST", body: JSON.stringify(payload) }),
  get: (id: string) => apiRequest<Timesheet>(`/api/timesheets/${id}`),
  adjust: (id: string, payload: CreateTimesheetAdjustment) =>
    apiRequest<Timesheet>(`/api/timesheets/${id}/adjustments`, { method: "POST", body: JSON.stringify(payload) }),
  submit: (id: string, payload: VersionCommand) => transition(id, "submit", payload),
  approve: (id: string, payload: VersionCommand) => transition(id, "approve", payload),
  lock: (id: string, payload: VersionCommand) => transition(id, "lock", payload),
  reject: (id: string, payload: RejectTimesheetPayload) =>
    apiRequest<Timesheet>(`/api/timesheets/${id}/reject`, { method: "POST", body: JSON.stringify(payload) }),
  saveXeroMapping: (userId: string, payload: PayrollMappingPayload) =>
    apiRequest<PayrollMapping>(`/api/timesheets/xero-mappings/${userId}`, { method: "PUT", body: JSON.stringify(payload) }),
};

const transition = (id: string, action: "submit" | "approve" | "lock", payload: VersionCommand) =>
  apiRequest<Timesheet>(`/api/timesheets/${id}/${action}`, { method: "POST", body: JSON.stringify(payload) });
